import { connect } from 'react-redux'
import { Link } from 'redux-little-router'
import { bool, string } from 'prop-types'
import React from 'react'
import { buildRefineHref, determineFiltersIsOpen } from '../../selectors'

const RefineLink = (props) => {
  if (props.filtersIsOpen) {
    return (
      <Link className="refine-link is-open" href={props.href} replaceState>
        Refine
      </Link>
    )
  }
  return (
    <Link className="refine-link" href={props.href} replaceState>Refine</Link>
  )
}
RefineLink.propTypes = {
  filtersIsOpen: bool.isRequired,
  href: string.isRequired,
}

const mapStateToProps = state => ({
  filtersIsOpen: determineFiltersIsOpen(state),
  href: buildRefineHref(state),
})

export default connect(mapStateToProps, {
})(RefineLink)
